import React from 'react';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import constants from '../../utils/constants';
import { ThemeProvider } from '@mui/material/styles';

const index = ({ value, className, mode, maxLength, disabled, id, name, help, onChange, design, onBlur, symbol, onFocus, mandatory }) => {

  const handleChange = (event) => {
    onChange(event);
  };

  const handleFocus = (event, newValue) => {
    if (onFocus) {
      onFocus(event, newValue);
    }
  };

  const onFormatNumber = (e) => {
    if (onBlur)
      onBlur(e);
  }

  //const inputWidth = value ? (value.length > 20 ? `${Math.min(value.length, 256)}ch` : '5px') : (name.length * 5);
  //const inputWidth = value ? (value.length > name.length ? (value.length < 20 ? `${value.length * 7 - 2}px` : `${value.length * 5.6 - 2}px`) : `${name.length * 6.25}px`) : (name.length * 10);
  //const inputWidth = value ? (value.length > name.length ? (value.length < 20 ? `${value.length * 7 - 2}px` : `${value.length * 5.6 - 2}px`) : `${name.length * 6.25}px`) : "0px";
  //const minWidth = name.length + "em"
  //const inputWidth = value ? (value.length > name.length ? `${value.length * 7 - 2}px` : `${name.length * 6.25}px`) : name.length + "em";
  const inputWidth = value ? `${value.length}ch` : '0ch';
  const minWidth = name.length + "ch";

  return (
    <ThemeProvider theme={constants.CUSTOM_MUI_TEXT_FIELD_THEME}>
      <Tooltip title={help} placement="top">
        <TextField
          inputProps={{ maxLength: maxLength, readOnly: mode, style: { height: '1px', width: inputWidth, minWidth: minWidth, fontWeight: '600', fontSize: 'inherit', lineHeight: 'inherit', paddingRight: "8px", paddingLeft: "0px", alignItems: "baseline", letterSpacing: "0.01rem" } }}
          disabled={disabled}
          key={id}
          id={id}
          InputLabelProps={{ shrink: true, style: { fontSize: 'inherit', lineHeight: 'inherit' } }}
          label={design !== 'table' ? <span>
            {name}
            {mandatory ? <span style={{ color: 'red' }}> *</span> : ''}
          </span> : null}
          variant="outlined"
          value={value}
          onChange={handleChange}
          className={className ?? undefined}
          InputProps={{
            startAdornment: symbol,
            inputProps: {
              readOnly: mode,
              style: { height: '1px', textAlign: 'right', width: inputWidth, /*minWidth: '100'*/minWidth: minWidth, fontWeight: '600', fontSize: 'inherit', lineHeight: 'inherit', paddingRight: "8px", paddingLeft: "0px", alignItems: "baseline", letterSpacing: "0.01rem" },
            },
          }}
          onBlur={onFormatNumber}
          onFocus={(event, newValue) => handleFocus(event, newValue)}

        />
      </Tooltip>
    </ThemeProvider>
  )
}

export default index